import { useState } from 'react'
import { FileBarChart, ArrowRight, Building2, TrendingUp } from 'lucide-react'
import { ONEReportCDV } from './ONEReportCDV'
import { FinancialReport } from './FinancialReport'

type ReportView = 'hub' | 'one-cdv' | 'financial'

export function ReportsManagement() {
  const [currentView, setCurrentView] = useState<ReportView>('hub')

  if (currentView === 'one-cdv') {
    return <ONEReportCDV onBack={() => setCurrentView('hub')} />
  }
  if (currentView === 'financial') {
    return <FinancialReport onBack={() => setCurrentView('hub')} />
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Rapports</h1>
        <p className="text-gray-600">Generation et export des rapports officiels</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <button
          onClick={() => setCurrentView('one-cdv')}
          className="group relative bg-white rounded-xl shadow-sm border border-gray-200 p-8 text-left hover:shadow-md hover:border-blue-300 transition-all duration-200"
        >
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0 w-12 h-12 bg-blue-50 rounded-lg flex items-center justify-center group-hover:bg-blue-100 transition-colors">
              <FileBarChart className="h-6 w-6 text-blue-600" />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-1">Rapports ONE CDV</h3>
              <p className="text-sm text-gray-500">Presences et listes d'enfants pour les rapports ONE des Centres de Vacances.</p>
            </div>
          </div>
          <ArrowRight className="absolute top-8 right-6 h-5 w-5 text-gray-300 group-hover:text-blue-500 transition-colors" />
        </button>

        <button
          onClick={() => setCurrentView('financial')}
          className="group relative bg-white rounded-xl shadow-sm border border-gray-200 p-8 text-left hover:shadow-md hover:border-emerald-300 transition-all duration-200"
        >
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0 w-12 h-12 bg-emerald-50 rounded-lg flex items-center justify-center group-hover:bg-emerald-100 transition-colors">
              <TrendingUp className="h-6 w-6 text-emerald-600" />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-1">Rapport financier</h3>
              <p className="text-sm text-gray-500">Analyse des inscriptions, paiements, factures et taux de recouvrement.</p>
            </div>
          </div>
          <ArrowRight className="absolute top-8 right-6 h-5 w-5 text-gray-300 group-hover:text-emerald-500 transition-colors" />
        </button>

        <div className="relative bg-white rounded-xl shadow-sm border border-gray-200 p-8 text-left opacity-50 cursor-not-allowed">
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0 w-12 h-12 bg-gray-50 rounded-lg flex items-center justify-center">
              <Building2 className="h-6 w-6 text-gray-400" />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-1">Rapports PAD</h3>
              <p className="text-sm text-gray-500">Rapports pour les Plaines Aventure Decouverte.</p>
            </div>
          </div>
          <span className="absolute top-4 right-4 text-xs bg-gray-100 text-gray-500 px-2 py-0.5 rounded-full">Bientot</span>
        </div>


      </div>
    </div>
  )
}
